@if (savedInstallationReportsResponse$ | async; as savedInstallationReports) {
  @if (savedInstallationReports.isLoading || isLoading) {
    <ipo-loading-spinner></ipo-loading-spinner>
  } @else {
    @if (savedInstallationReports.data) {
      <app-installation-report-table
        [ifs]="ifsNumber"
        [installationReports]="installationReports"
        [filterText]="filterText"
        [filterFields]="filterFields"
        [isLoading]="isLoading"
        [currentDomainColumns]="currentDomainColumns"
        [savedInstallationReportsForProject]="savedInstallationReports.data"
        (rowClicked)="openInstallationReportModal($event)"
      ></app-installation-report-table>
    }
  }
}
